import { useState, useEffect, useRef } from "react";
import style from "./CreateTask.module.css";
import AdminNavBar from "../../NavBar/AdminNavBar";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";
import { useParams, useNavigate } from "react-router";

export default function CreateTask() {

    const apiUrl = process.env.REACT_APP_SERVER_URL;
    const [users, setUsers] = useState([]);
    const [loadingUsers] = useState(false);
    const [error, setError] = useState("");
    const selectRef = useRef(null);
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const { employeeId } = useParams()

    const [formData, setFormData] = useState({
        title: "",
        description: "",
        finishingDate: "",
        finishingTime: "",
        preferences: "",
        employeeId: [],
        assignedBy: employeeId,
        status: "Pending",
        priority: "Medium",
        category: "",
        attachments: [],
        timeSpent: 0,
    });

    // Fetch employees from backend
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await fetch(`${apiUrl}/users`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                const data = await res.json();
                if (res.ok) {
                    setUsers(data.users || []);
                } else {
                    setError(data.message || "Failed to fetch users");
                }
            } catch (err) {
                setError(err.message);
            }
        };
        fetchUsers();
    }, [apiUrl, token]);

    // Handle text/select input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle employee selection
    const handleSelectEmployees = (e) => {
        const selectedId = e.target.value;
        if (selectedId && !formData.employeeId.includes(selectedId)) {
            setFormData({ ...formData, employeeId: [...formData.employeeId, selectedId] });
        }
        e.target.value = "";
    };

    // Remove last selected employee
    const handleRemoveLast = () => {
        setFormData({ ...formData, employeeId: formData.employeeId.slice(0, -1) });
    };

    // Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiUrl}/tasks/create-tasks`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
            });

            const data = await res.json();
            if (res.ok) {
                alert("✅ Task created successfully!");
                // reset form
                setFormData({
                    title: "",
                    description: "",
                    finishingDate: "",
                    finishingTime: "",
                    preferences: "",
                    employeeId: [],
                    assignedBy: "",
                    status: "Pending",
                    priority: "Medium",
                    category: "",
                    attachments: [],
                    timeSpent: 0,
                });
                navigate(`/admin-dashboard/${employeeId}/all-tasks`);
            } else {
                alert("❌ Failed to create task: " + data.message);
            }
        } catch (err) {
            alert("❌ Network error");
        }
    };

    const availableEmployees = users.filter(
        (u) => u.role === "Employee" && !formData.employeeId.includes(u.employeeId)
    );

    return (
        <>
            <AdminNavBar />
            <div className="container">

                <div className="row mt-lg-2 mb-0 ">

                    {error && <p className="text-danger text-center">{error}</p>}

                    {/* BreadCrumb Linkss */}
                    <div className="col-8 col-lg-5 ">
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}`}
                            name="Dashboard"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}/all-tasks`}
                            name="All Projects"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${employeeId}/all-tasks/create-task`}
                            name="Create a New Task"
                        />
                    </div>
                </div>

                <div className={style.createTaskPage}>
                    <div className="container mt-4">
                        <div className={style.pageContainer}>
                            <h2 className={style.heading}>Create New Task</h2>
                            <form
                                onSubmit={handleSubmit}
                                className="row g-3 pb-3"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") e.preventDefault();
                                }}
                            >
                                {/* Title & Description */}
                                <div className="col-md-6">
                                    <label className="form-label">Title</label>
                                    <input
                                        type="text"
                                        name="title"
                                        className="form-control"
                                        placeholder="Task Title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Description</label>
                                    <input
                                        type="text"
                                        name="description"
                                        className="form-control"
                                        placeholder="Description"
                                        value={formData.description}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Finishing Date & Time + Preferences */}
                                <div className="col-lg-6 mt-3">
                                    <div className="row g-2 align-items-center">
                                        <div className="col-12 col-sm-6">
                                            <label className="form-label">Finishing Date</label>
                                            <input
                                                type="date"
                                                name="finishingDate"
                                                className="form-control"
                                                value={formData.finishingDate}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <label className="form-label">Finishing Time</label>
                                            <input
                                                type="time"
                                                name="finishingTime"
                                                className="form-control"
                                                value={formData.finishingTime}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 mt-3">
                                    <label className="form-label">Preferences</label>
                                    <input
                                        type="text"
                                        name="preferences"
                                        className="form-control"
                                        placeholder="Preferences"
                                        value={formData.preferences}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {/* Assign Employees */}
                                <div className="col-lg-6 mt-3">
                                    <label className="form-label">Assign Employees</label>
                                    <select
                                        ref={selectRef}
                                        className="form-select"
                                        onChange={handleSelectEmployees}
                                        value=""
                                    >
                                        <option value="">Select Employee</option>
                                        {loadingUsers ? (
                                            <option disabled>Loading...</option>
                                        ) : (
                                            availableEmployees.map((u) => (
                                                <option key={u.employeeId} value={u.employeeId}>
                                                    {u.employeeId} - {u.name}
                                                </option>
                                            ))
                                        )}
                                    </select>
                                </div>

                                <div className="col-lg-6 mt-3">
                                    <label className="form-label">Assigned Employees</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            readOnly
                                            value={
                                                formData.employeeId.length > 0
                                                    ? formData.employeeId.join(", ")
                                                    : "None"
                                            }
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger"
                                            onClick={handleRemoveLast}
                                            disabled={formData.employeeId.length === 0}
                                        >
                                            clear
                                        </button>
                                    </div>
                                </div>


                                {/* Status, Priority, Category */}
                                <div className="col-lg-4 mt-3">
                                    <select
                                        name="status"
                                        className="form-select"
                                        value={formData.status}
                                        onChange={handleChange}
                                    >
                                        <option value="">Status</option>
                                        <option value="Pending">Pending</option>
                                        <option value="In Progress">In Progress</option>
                                        <option value="Completed">Completed</option>
                                        <option value="On Hold">On Hold</option>
                                    </select>
                                </div>

                                <div className="col-lg-4 mt-3">
                                    <select
                                        name="priority"
                                        className="form-select"
                                        value={formData.priority}
                                        onChange={handleChange}
                                    >
                                        <option value="">Priority</option>
                                        <option value="Low">Low</option>
                                        <option value="Medium">Medium</option>
                                        <option value="High">High</option>
                                        <option value="Critical">Critical</option>
                                    </select>
                                </div>

                                <div className="col-lg-4 mt-3">
                                    <input
                                        type="text"
                                        name="category"
                                        className="form-control"
                                        placeholder="Category"
                                        value={formData.category}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* Submit Button */}
                                <div className="col-12 text-center mt-4 mb-3">
                                    <button type="submit" className="btn btn-primary px-4">
                                        Create Task
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
